import React from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { getGasData, downloadGasXls } from "../../modules/gas";
import { changeTitle } from "../../modules/navigation";
import { DOMAIN } from "./../../utilities/consts";
import GasView from "./GasView";
import { formatDateString } from "./../../utilities/datesFormatter";

class Gas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAlertMessageOpen: false,
      alertMessage: "",
      isInComparativeMode: false
    };
  }

  componentDidMount() {
    this.props.changeTitle("Gas");
  }

  openAlertMessage = message => {
    this.setState({
      isAlertMessageOpen: true,
      alertMessage: message
    });
  };

  handleCloseAlertMessage = () => {
    this.setState({
      isAlertMessageOpen: false,
      message: ""
    });
  };

  handleCompare = () => {
    this.setState({ isInComparativeMode: !this.state.isInComparativeMode });
  };

  fetchData = () => {
    const config = {
      fechaInicial: this.props.startDate.valueOf(),
      fechaFinal: this.props.endDate.valueOf(),
      unidades: this.props.selectedUnits,
      zona: this.props.zone
    };

    if (config.unidades.length === 0) {
      this.openAlertMessage(this.props.lang.SeleccioneAlMenosUnaUnidad);
      return;
    }

    this.props.getGasData(config);
  };

  downloadExcel = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades = this.props.selectedUnits,
      zona = this.props.zone;

    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=gas&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}`,
      "_blank"
    );
  };

  downloadPdf = () => {
    const fechaInicial = this.props.startDate.valueOf(),
      fechaFinal = this.props.endDate.valueOf(),
      lang = this.props.lang._code === "en" ? "en-US" : "es-MX",
      unidades = this.props.selectedUnits,
      zona = this.props.zone;

    window.open(
      `${DOMAIN}/GenerarReporte.aspx?sTipoReporte=gasPDF&fInicial=${fechaInicial}&fFinal=${fechaFinal}&aUnidades=${unidades}&zona=${zona}&lang=${lang}`,
      "_blank"
    );
  };

  render() {
    return (
      <GasView
        fetchData={this.fetchData}
        downloadExcel={this.downloadExcel}
        downloadPdf={this.downloadPdf}
        openAlertMessage={this.openAlertMessage}
        handleCloseAlertMessage={this.handleCloseAlertMessage}
        isAlertMessageOpen={this.state.isAlertMessageOpen}
        alertMessage={this.state.alertMessage}
        handleCompare={this.handleCompare}
        isInComparativeMode={this.state.isInComparativeMode}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  const hasData = state.gas.hasData;
  let services = state.gas.data.TotalServicios;

  return {
    reportData: state.gas.data,
    isLoading: state.gas.isLoading,
    hasData,
    lang: state.internationalization.lang,
    units: state.units.data,
    selectedUnits: state.units.selectedUnits,
    permissions: state.permissions.data,
    loadedPermissions: state.permissions.loadedPermissions,
    startDate: state.dates.startDate,
    endDate: state.dates.endDate,
    zone: state.dates.zone,
    firstLocationDate: state.gas.data.FechaInicial,
    lastLocationDate: state.gas.data.FechaFinal,
    services,
    discountSales: state.gas.data.TotalVentasDescuento
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getGasData,
      downloadGasXls,
      changeTitle
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Gas);



// WEBPACK FOOTER //
// ./src/containers/Gas/Gas.js